import { numberFormatter } from "@/utils";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { useSelector } from "react-redux";

const LayoutCounter = ({ data, apiData }) => {
  const { isDark } = useSelector((state) => state.theme);

  const {
    chartTitle,
    valueFontSize,
    counterType = "content-middle",
    iconColor,
    iconBgColor,
    fontColor,
    icon,
    counterValue,
    counterDataType = "parameter",
    showUnit,
    counterUnit,
    isTitleHidden,
    valueColor,
    counterBg,
    dynamicBg,
    counterBgLevels,
    defaultCounterBg = "#fff",
  } = data;

  const value = apiData?.data || {};
  const unit = apiData?.unit || "";
  const [background, setBackground] = useState("");

  // set bg color
  useEffect(() => {
    if (dynamicBg) {
      if (value?.value || counterValue) {
        const number = value.value || counterValue || 0;
        const sortArr = (Array.isArray(counterBgLevels) && [...counterBgLevels].sort((a, b) => Number(a.level) - Number(b.level))) || [];

        for (let i = sortArr?.length - 1; i >= 0; i--) {
          if (sortArr[i]) {
            const { level, color } = sortArr[i];
            if (number >= Number(level)) {
              setBackground(color);
              break;
            } else {
              setBackground(defaultCounterBg);
            }
          } else {
            break;
          }
        }
      }
    } else {
      if (isDark) {
        setBackground("");
      } else {
        let bgValue;
        if (Array.isArray(counterBg) && counterBg?.length) {
          if (counterBg?.length > 1) {
            let color = counterBg.map((item) => item?.color || "#fff").join();
            bgValue = `linear-gradient(150deg, ${color})`;
          } else {
            bgValue = counterBg[0]?.color || "#fff";
          }
        }

        setBackground(bgValue);
      }
    }
  }, [isDark, counterBg, dynamicBg, value, counterValue, counterBgLevels, defaultCounterBg]);

  const CounterIcon = () => (
    <div
      className="counter_icon"
      style={{
        backgroundColor: iconBgColor ? iconBgColor : "#1677ff31",
        color: iconColor ? iconColor : "#1677ff",
      }}
    >
      {icon && React.createElement(FaIcons[icon])}
    </div>
  );

  const CounterText = ({ align }) => (
    <div className="counter_text" style={{ textAlign: align, color: fontColor }}>
      {!isTitleHidden && (
        <div className="ql">
          <div className="ql-editor p-0 pb-1" style={{ textAlign: align }}>
            <div dangerouslySetInnerHTML={{ __html: chartTitle }}></div>
          </div>
        </div>
      )}
      <h3 className="mb-0" style={{ fontSize: valueFontSize ? `${valueFontSize}pt` : "14pt", color: valueColor }}>
        {counterDataType === "parameter" ? (
          <>
            {value?.value ? numberFormatter(value.value) : 0} {showUnit && <strong>{unit}</strong>}
          </>
        ) : (
          <>
            {counterValue} {showUnit && <strong>{counterUnit}</strong>}
          </>
        )}
      </h3>
    </div>
  );

  CounterText.propTypes = {
    align: PropTypes.string,
  };

  const layoutOptions = {
    "icon-left-content-right": (
      <div className="counter p-3" style={{ justifyContent: "space-between", height: "100%" }}>
        <CounterIcon />
        <CounterText align="right" />
      </div>
    ),
    "icon-right-content-left": (
      <div className="counter p-3" style={{ justifyContent: "space-between", height: "100%" }}>
        <CounterText align="left" />
        <CounterIcon />
      </div>
    ),
    "content-middle": (
      <div className="counter p-3" style={{ justifyContent: "center", height: "100%" }}>
        <CounterText align="center" />
      </div>
    ),
    "content-left": (
      <div className="counter p-3" style={{ justifyContent: "start", height: "100%" }}>
        <CounterText align="left" />
      </div>
    ),
    "content-right": (
      <div className="counter p-3" style={{ justifyContent: "end", height: "100%" }}>
        <CounterText align="right" />
      </div>
    ),
  };

  return (
    <div
      className="w-100 h-100 test"
      style={{
        background,
      }}
    >
      {layoutOptions[counterType]}
    </div>
  );
};

export default LayoutCounter;

LayoutCounter.propTypes = {
  data: PropTypes.object.isRequired,
  mainDashboard: PropTypes.bool,
  apiData: PropTypes.object,
};
